import { render } from "./DashboardProgressChart.vue?vue&type=template&id=51a1edaa"
import script from "./DashboardProgressChart.vue?vue&type=script&lang=js"
export * from "./DashboardProgressChart.vue?vue&type=script&lang=js"

import "./DashboardProgressChart.vue?vue&type=style&index=0&id=51a1edaa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__